<template>
  <div>
    <div class="home-menu">
      <div
        class="home-menu-item flex-column jusitify-center align-center"
        v-for="(item, index) in menuList"
        :key="index"
        @click="handleItem(item)"
      >
        <img class="home-menu-icon" :src="item.icon" alt="" />
        <span>{{ item.name }}</span>
      </div>
    </div>
    <warning-login :show.sync="showLogin" />

    <!-- <experience-gold :show.sync="showExperienceGold" /> -->
    <prize-draw :show.sync="showPrizeDraw" />

    <coupon :show.sync="showcoupon" />
  </div>
</template>

<script>
import WarningLogin from '@/components/base/warning-login.vue';
// import ExperienceGold from "@/components/base/experience-gold.vue";
import prizeDraw from '@/components/base/prize-draw.vue';

import Coupon from '@/components/base/coupon.vue';

import { queryCashConfig, checkIsLogin } from '@/api/api';
import { obj2Param } from '@/libs/tools';

export default {
  name: 'HomeMenu',
  components: {
    WarningLogin,
    Coupon,
    prizeDraw,
    // ExperienceGold,
  },
  data() {
    return {
      showExperienceGold: false,
      showPrizeDraw: false,
      showcoupon: false,
      showLogin: false, //判断当前是否登录
      menuType: 2, //1:4个, 2:8个

      menuList: [
        {
          icon: require('@/assets/images/home/quickpay.png'),
          name: '快捷缴费',
          key: '/pay/quickPay',
        },

        {
          icon: require('@/assets/images/home/searchparking.png'),
          name: '泊位停车',
          key: '/berthParking',
        },
        {
          icon: require('@/assets/images/home/parkpay.png'),
          name: '欠费补缴',
          key: 'bill',
        },
        {
          icon: require('@/assets/images/home/monthcard.png'),
          name: '购买月卡',
          key: 'mouthCar',
        },

        // {
        //     icon: require("@/assets/images/home/monthcard.png"),
        //     name: "客服帮助",
        //     key: "suggestion",
        // },

        {
          icon: require('@/assets/images/home/scanpay.png'),
          name: '扫码缴费',
          key: 'qrCode',
        },

        {
          icon: require('@/assets/images/home/mycar.png'),
          name: '我的车辆',
          key: '/mycar',
        },

        {
          icon: require('@/assets/images/home/parkrecord.png'),
          name: '停车记录',
          key: '/record',
        },

        {
          icon: require('@/assets/images/home/elbill.png'),
          name: '电子发票',
          key: 'invoice',
        },
      ],
    };
  },
  computed: {},
  mounted() {
    if (localStorage.getItem('givingCouponsNum') > 0) {
      this.showcoupon = true;
      localStorage.setItem('givingCouponsNum', 0);
    }

    if (localStorage.getItem('userId')) {
      queryCashConfig({ type: 3 }).then((res) => {
        if (res.data) {
          this.showExperienceGold = true;
        }
      });
    }
  },
  methods: {
    //菜单点击事件,这个函数有点恶心
    handleItem(item) {
      checkIsLogin().then((res) => {
        if (res.data == 0) {
          this.showLogin = true;
          return;
        } else {
          if (item.key == 'qrCode') {
            wx.miniProgram.navigateTo({
              url: `/pages/scan/scan`,
            });
          } else if (item.key == 'bill') {
            let obj = {
              token: localStorage.getItem('token'),
              userId: localStorage.getItem('userId'),
              xcxOpenId: localStorage.getItem('openId'),
              plateNum: localStorage.getItem('openId'),
            };
            let str = `${
              process.env.VUE_APP_BASE_API
            }qginsideparking/page/plateNumBill?${obj2Param(obj)}`;
            wx.miniProgram.navigateTo({
              url: `/pages/tab2/webview/webview?jumpUrl=${encodeURIComponent(
                str,
              )}`,
            });
          } else if (item.key == 'mouthCar') {
            let obj = {
              token: localStorage.getItem('token'),
              userId: localStorage.getItem('userId'),
              xcxOpenId: localStorage.getItem('openId'),
            };
            let str = `${
              process.env.VUE_APP_BASE_API
            }qgvip/monthlyCar/listIndex?${obj2Param(obj)}`;

            wx.miniProgram.navigateTo({
              url: `/pages/tab2/webview/webview?jumpUrl=${encodeURIComponent(
                str,
              )}`,
            });
          } else if (item.key == 'invoice') {
            let obj = {
              token: localStorage.getItem('token'),
              userId: localStorage.getItem('userId'),
              xcxOpenId: localStorage.getItem('openId'),
            };
            let str = `${
              process.env.VUE_APP_BASE_API
            }qgvip/elecTicket/electronicTicketHome?${obj2Param(obj)}`;
            wx.miniProgram.navigateTo({
              url: `/pages/tab2/webview/webview?jumpUrl=${encodeURIComponent(
                str,
              )}`,
            });
          } else {
            this.$router.push(item.key);
          }
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.home-menu {
  display: grid;
  grid-template-columns: repeat(4, 1fr);

  .home-menu-item {
    color: #999999;
    padding-top: 28px;

    .home-menu-icon {
      width: 100px;
      height: 100px;
      margin-bottom: 6px;
    }
  }
}
</style>
